import { resolveDiPdfFilename } from 'service/DiIdentity';
import React, {  useEffect, useState, useCallback, useRef } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next" 
import { useNavigate } from 'react-router-dom'; 
import { ENDPOINT } from "constants/variables";
import { TEXT_SIGN_1,TEXT_SIGN_2,TEXT_SIGN_3,TEXT_SIGN_4,TEXT_SIGN_5,CANVAS_SIZE,CLIENTEFIRMA } from "constants/variables"; 
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button'; 
import Card from '@mui/material/Card';   
import CardContent from '@mui/material/CardContent'; 
import CircularProgress from '@mui/material/CircularProgress'; 
import Grid  from '@mui/material/Grid';
import SignatureCanvas from 'react-signature-canvas';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LoadingNews } from "components/utils/LoadingNews"; 
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import { helpHttp } from "service/HelpHttp"; 
import { NumericFormat } from 'react-number-format';
import { PDFDocument,rgb } from "pdf-lib";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import { esirCoordinatesFromText } from "./esirPdfCoordinates";
import { setLoading } from 'reducers/loadingSlice';
import { setReloadRefreshData } from 'reducers/loadingSlice'; 
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import signFrancisco from "components/photos/signs/SelloFrancisco.png"; 
import signGonzalo from "components/photos/signs/SelloGonzalo.png"; 
import signGuillermo from "components/photos/signs/SelloGuillermo.png"; 
import signJorge from "components/photos/signs/SelloJorge.png"; 
import signKirian from "components/photos/signs/SelloKirian.png"; 
import signBentahor from "components/photos/signs/Bentahor/SelloBentahor.png"; 
import signDiego from "components/photos/signs/Bentahor/SelloDiego.png"; 
import signMario from "components/photos/signs/Bentahor/SelloMario.png"; 
import signRoberto from "components/photos/signs/Bentahor/SelloRoberto.png"
import signSantiago from "components/photos/signs/Bentahor/SelloSantiago.png"; 
  
import "css/generalSettings.css";
import "css/customDialog.css";   
import "css/generalSettings.css";
import "css/customDialog.css";   


GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.js", import.meta.url).toString();

const initialStateForm = {
  "id" : "",
  "ownformdi_id" : "", 
  "defaultStore_id":0, 
  "useraccount_id":0, 
  "defaultformatnumber":1,
  "isFinished":false,
  "isScanned":false,
  "hasbeenfinishedscanned":false,
  "numberDI_sheet" : "", 
  "number_dt":"",
  "date_sheet":"", 
  "licenseplate":"", 
  "amount" : 0,   
  "deliver_date":"",
  "delivery_quantity":0,
  "accept":"Text_NOT_REPORTING",
  "date_accepted":"",
  "observations":"",
  "date_refund":"",
  "reason_refund":"",
  "action_refund":"",
  "signature_opt_tras":"" ,
  "signature_dest_tras":"" ,
  "signature_refund":"" ,
  
  "typeofconvertpdf" : 0,
  "xcoord_licenseplate": 0,
  "ycoord_licenseplate": 0,
  "xcoord_amount" : 0,
  "ycoord_amount" : 0,
  "xcoord_deliver_date" : 0,
  "ycoord_deliver_date" : 0,
  "xcoord_delivery_quantity" : 0,
  "ycoord_delivery_quantity" : 0,
  "xcoord_date_accepted" : 0,
  "ycoord_date_accepted" : 0,
  "xcoord_accept" : 0,
  "ycoord_accept" : 0,
  "xcoord_date_refund" : 0,
  "ycoord_date_refund" : 0,
  "xcoord_reason_refund" : 0,
  "ycoord_reason_refund" : 0,
  "xcoord_action_refund" : 0,
  "ycoord_action_refund" : 0,
  "xcoord_observations" : 0,
  "ycoord_observations" : 0, 
  "xcoordsignaturerefund" : 0,
  "ycoordsignaturerefund" : 0,
  "pdfUrl":"" 
};

const textAccepted=[
  {"id":1,"name":"Text_NOT_REPORTING"},
  {"id":2,"name":"Text_FORM_IsAccept"},
  {"id":3,"name":"Text_FORM_IsNotAccept"},
  {"id":4,"name":"Text_FORM_IsAnnulled"}];

export const FormEdiFormDISignatureCreate = ({id, showModalFormDISignature,typeOfList}) => {
  const { t, i18n } = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);  
  const reason_refund_view = useSelector((state) => state.formatDIUser.reason_refund_view);
  const action_refund_view = useSelector((state) => state.formatDIUser.action_refund_view);
  const date_refund_view = useSelector((state) => state.formatDIUser.date_refund_view);
  const date_refund_handle = useSelector((state) => state.formatDIUser.date_refund_handle);
  const reason_refund_handle = useSelector((state) => state.formatDIUser.reason_refund_handle);
  const action_refund_handle = useSelector((state) => state.formatDIUser.action_refund_handle);
  const isLoadingData = useSelector((state) => state.loading.isLoading);   
  const [dataFormDISignature, setDataFormDISignature] = useState(initialStateForm);
  const [errorsFormDISignature, setErrorsFormDISignature] = useState({});
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [enabledAmount, setEnabledAmount] = useState(true);  
  const [sharedsignOptTras, setSharedsignOptTras] = useState(false);
  const [sharedsignDestTras, setSharedsignDestTras] = useState(false);
  const [sharedsignRefund, setSharedsignRefund] = useState(false);
  const signDispatchedOptTrasCanvas = useRef(null);
  const signDispatchedDestTrasCanvas = useRef(null);
  const signDispatchedRefundCanvas = useRef(null);
  const [pdfUrl, setPdfUrl] = useState(""); // Estado para actualizar el PDF
  const [originalPdfUrl, setOriginalPdfUrl] = useState("");  
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalFormDISignature) {
        setDataFormDISignature(initialStateForm);
        setErrorsFormDISignature({}); 
        setIsLoadingErrorData(false);
        setEnabledAmount(true); 
        setPdfUrl("");
        setOriginalPdfUrl(""); 
        dispatch(setLoading(false));
        dispatch(setReloadRefreshData(true));
        setSharedsignOptTras(false);
        setSharedsignDestTras(false);
        setSharedsignRefund(false);
        if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
        if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
        if (signDispatchedRefundCanvas.current) signDispatchedRefundCanvas.current.clear();
        navigate(typeOfList==="1"?"/formdi":"/formdiended") ;
        return () => {};
      }
    },
    [
      showModalFormDISignature,
      setErrorsFormDISignature,
      setPdfUrl,
      setOriginalPdfUrl,
      setEnabledAmount,  
      setSharedsignOptTras,
      setSharedsignDestTras,
      setSharedsignRefund,
      typeOfList,
      dispatch,
      navigate]
  );
  
  const handleCloseDataEditFormDISignature = () => {
    setDataFormDISignature(initialStateForm);
    setErrorsFormDISignature({}); 
    setIsLoadingErrorData(false);
    setEnabledAmount(true);   
    setPdfUrl("");
    setOriginalPdfUrl(""); 
    dispatch(setLoading(false));
    dispatch(setReloadRefreshData(true));
    setSharedsignOptTras(false);
    setSharedsignDestTras(false);
    setSharedsignRefund(false);
    if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
    if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
    if (signDispatchedRefundCanvas.current) signDispatchedRefundCanvas.current.clear();
    navigate(typeOfList==="1"?"/formdi":"/formdiended") ;
    return () => {};
	};
 
  const deleteSignature = (id) => {
    switch (id) {
      case 1:   
      if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
        setDataFormDISignature(dataFormDISignature => ({
          ...dataFormDISignature,
          signature_opt_tras: "",
        })); 
        break;
      case 2:    
      if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
        setDataFormDISignature(dataFormDISignature => ({
          ...dataFormDISignature,
          signature_dest_tras: "",
        }));
        break;
      case 3:    
      if (signDispatchedRefundCanvas.current) signDispatchedRefundCanvas.current.clear();
        setDataFormDISignature(dataFormDISignature => ({
          ...dataFormDISignature,
          signature_refund: "",
        }));
        break; 
      default:
        break;
    } 
  }; 

  const handleRemoveSignature = () => {
    setPdfUrl(originalPdfUrl); // Restaurar el PDF original 
    setDataFormDISignature(dataFormDISignature => ({
      ...dataFormDISignature,
      pdfUrl: ""
    })); 
  };

  const drawSignatureCentered = (canvasRef, base64) => {
    if (!canvasRef?.current || !base64) return;
    const canvas = canvasRef.current.getCanvas();
    const ctx = canvas.getContext("2d");
    // 🔒 Forzar tamaño interno fijo
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
    };
  };

  const drawPredefinedSignature = (imageSrc) => {
    if (!signDispatchedOptTrasCanvas.current) return;
    const canvasRef = signDispatchedOptTrasCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setDataFormDISignature(dataFormDISignature => ({
        ...dataFormDISignature,
        signature_opt_tras: base64
      }));
    };
  };

  const drawPredefinedSignatureDestTras = (imageSrc) => {
    if (!signDispatchedDestTrasCanvas.current) return;
    const canvasRef = signDispatchedDestTrasCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setDataFormDISignature(dataFormDISignature => ({
        ...dataFormDISignature,
        signature_dest_tras: base64
      }));
    };
  };

  const drawPredefinedSignatureRefund = (imageSrc) => {
    if (!signDispatchedRefundCanvas.current) return;
    const canvasRef = signDispatchedRefundCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setDataFormDISignature(dataFormDISignature => ({
        ...dataFormDISignature,
        signature_refund: base64
      }));
    };
  };

  const predefinedSignaturesArena = [
    signFrancisco,
    signGonzalo,
    signGuillermo,
    signJorge,
    signKirian
  ];

  const predefinedSignaturesBentahor = [
    signBentahor,
    signDiego,
    signMario,
    signRoberto,
    signSantiago
  ];
         
  // Función para formatear el número
  const formatNumberWithKg = (num) => {
    num = (num == null || num === "" || isNaN(Number(num))) ? 0 : num;
    return num.toLocaleString('es-ES', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' Kg';
  };
 
  function getDateFormated(getDate) {
    const meses = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    if (getDate !==null && getDate !==""){
      const hoy =new Date(getDate);
      const dia = hoy.getDate();
      const mes = meses[hoy.getMonth()];
      const año = hoy.getFullYear();
      return `${dia}/${mes}/${año}`;
    }else{
      return "";
    } 
  } 
  const insertDateInPDF = async (pdfUrl, signatureOptTrasCanvas,signatureOriTrasCanvas,signatureCanvas, setPdfUrl) => {
  
    const existingPdfBytes = await fetch(pdfUrl).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes); 
    const pages = pdfDoc.getPages();
    const firstPage = pages[0]; // Puedes cambiar la página si lo necesitas
    const secondPage = pages[1]; // Puedes cambiar la página si lo necesitas 
    try {
      let coordinates = {};
      if (dataFormDISignature.typeofconvertpdf === 2) {
        const source = await getDocument({ data: existingPdfBytes.slice(0) }).promise;
        try {
          const page = await source.getPage(2);
          coordinates = esirCoordinatesFromText((await page.getTextContent()).items);
        } finally {
          await source.destroy();
        }
      }
      const pdfData = { ...dataFormDISignature, ...coordinates };
      if (pdfData.typeofconvertpdf === 3 || pdfData.typeofconvertpdf === 6) {
        firstPage.drawRectangle({
          x: 0,
          y: pdfData.typeofconvertpdf === 6?500:480, // parte superior de una página A4 (altura = 842pt)
          width: firstPage.getWidth(),
          height: 20,
          color: rgb(1, 1, 0.6), // amarillo claro
        });
      
        firstPage.drawText("Este formulario contiene campos que serán modificados al guardar. La visualización actual es orientativa.", {
          x: 30,
          y: pdfData.typeofconvertpdf === 6?505:485,
          size: 10,
          color: rgb(0.2, 0.2, 0.2), // gris oscuro
        });
      }
      if ( signatureOptTrasCanvas.current && signatureOptTrasCanvas.current!=="" && !sharedsignOptTras){
        const signatureOptTrasDataUrl = signatureOptTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        const signatureOptTrasImageBytes = await fetch(signatureOptTrasDataUrl).then(res => res.arrayBuffer());
        const signatureOpTrasImage = await pdfDoc.embedPng(signatureOptTrasImageBytes);
         if (pdfData.typeofconvertpdf===4){
          firstPage.drawImage(signatureOpTrasImage, {
            x: 500, // Ajusta la posición X
            y: 690, // Ajusta la posición Y
            width:  70, // Ajusta el ancho de la firma
            height: 30  // Ajusta la altura de la firma
          }); 
        } else{
          if (pdfData.typeofconvertpdf===0 || pdfData.typeofconvertpdf===3){
            firstPage.drawImage(signatureOpTrasImage, {
              x: 450, // Ajusta la posición X
              y: 677, // Ajusta la posición Y
              width: 70, // Ajusta el ancho de la firma
              height: 30  // Ajusta la altura de la firma
            }); 
          }else{ 
            if (pdfData.typeofconvertpdf===5){
              secondPage.drawImage(signatureOpTrasImage, {
                x: 100, // Ajusta la posición X
                y: 200, // Ajusta la posición Y
                width: 100, // Ajusta el ancho de la firma
                height: 50  // Ajusta la altura de la firma
              });
            }else{
              if (pdfData.typeofconvertpdf===6){
                firstPage.drawImage(signatureOpTrasImage, {
                  x: 500, // Ajusta la posición X
                  y: 690, // Ajusta la posición Y
                  width:  70, // Ajusta el ancho de la firma
                  height: 30  // Ajusta la altura de la firma
                }); 
              }else{
                secondPage.drawImage(signatureOpTrasImage, {
                  x: 100, // Ajusta la posición X
                  y: 200, // Ajusta la posición Y
                  width: 100, // Ajusta el ancho de la firma
                  height: 50  // Ajusta la altura de la firma
                }); 
              }   
            }   
          } 
        } 
      } 
      if ( signatureOriTrasCanvas.current && signatureOriTrasCanvas.current!=="" && !sharedsignDestTras){
        const signatureOriTrasDataUrl = signatureOriTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        const signatureOriTrasImageBytes = await fetch(signatureOriTrasDataUrl).then(res => res.arrayBuffer());
        const signatureOriTrasImage = await pdfDoc.embedPng(signatureOriTrasImageBytes);
        if (pdfData.typeofconvertpdf===4){
          firstPage.drawImage(signatureOriTrasImage, {
            x: 150, // Ajusta la posición X
            y: 5, // Ajusta la posición Y
            width:  70, // Ajusta el ancho de la firma
            height: 30  // Ajusta la altura de la firma
          }); 
        } else{
          if (pdfData.typeofconvertpdf===1){ 
            firstPage.drawImage(signatureOriTrasImage, {
              x: 65, // Ajusta la posición X
              y: 45, // Ajusta la posición Y
              width: 100, // Ajusta el ancho de la firma
              height: 50  // Ajusta la altura de la firma
            });
          }else{
            if (pdfData.typeofconvertpdf===0 || pdfData.typeofconvertpdf===3){
              firstPage.drawImage(signatureOriTrasImage, {
                x: 160, // Ajusta la posición X
                y: 25, // Ajusta la posición Y
                width: 100, // Ajusta el ancho de la firma
                height: 50  // Ajusta la altura de la firma
              }); 
            }else{ 
              if (pdfData.typeofconvertpdf===5){
                secondPage.drawImage(signatureOriTrasImage, {
                  x: 130, // Ajusta la posición X
                  y: 380, // Ajusta la posición Y
                  width: 70, // Ajusta el ancho de la firma
                  height: 40  // Ajusta la altura de la firma
                }); 
              }else{
                if (pdfData.typeofconvertpdf===6){
                  firstPage.drawImage(signatureOriTrasImage, {
                    x: 250, // Ajusta la posición X
                    y: 35, // Ajusta la posición Y
                    width:  100, // Ajusta el ancho de la firma
                    height: 50  // Ajusta la altura de la firma
                  }); 
                }else{
                  secondPage.drawImage(signatureOriTrasImage, {
                    x: 170, // Ajusta la posición X
                    y: coordinates.ycoordsignaturerefund ?? 340, // Ajusta la posición Y
                    width: 70, // Ajusta el ancho de la firma
                    height: coordinates.ycoordsignaturerefund != null ? 22 : 40  // Ajusta la altura de la firma
                  });
                }   
              } 
            
            }
          }   
        } 
      } 
     if ( signatureCanvas.current && signatureCanvas.current!==""  && !sharedsignRefund){
        const signatureDataUrl = signatureCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        const signatureImageBytes = await fetch(signatureDataUrl).then(res => res.arrayBuffer());
        const signatureImage = await pdfDoc.embedPng(signatureImageBytes);
        if (pdfData.typeofconvertpdf===4){
          firstPage.drawImage(signatureImage, {
            x: 450, // Ajusta la posición X
            y: 5, // Ajusta la posición Y
            width:  80, // Ajusta el ancho de la firma
            height: 40  // Ajusta la altura de la firma
          }); 
        } else{
          if (pdfData.typeofconvertpdf===1){ 
            firstPage.drawImage(signatureImage, {
              x: 170, // Ajusta la posición X
              y: 45, // Ajusta la posición Y
              width: 100, // Ajusta el ancho de la firma
              height: 50  // Ajusta la altura de la firma
            }); 
          }else{
            if (pdfData.typeofconvertpdf===0 || pdfData.typeofconvertpdf===3){ 
                firstPage.drawImage(signatureImage, {
                  x: 430, // Ajusta la posición X
                  y: 25, // Ajusta la posición Y
                  width: 100, // Ajusta el ancho de la firma
                  height: 50  // Ajusta la altura de la firma
                }); 
            }else{ 
              if (pdfData.typeofconvertpdf===5){
                secondPage.drawImage(signatureImage, {
                  x: 400, // Ajusta la posición X
                  y: 380, // Ajusta la posición Y
                  width: 70, // Ajusta el ancho de la firma
                  height: 40  // Ajusta la altura de la firma
                }); 
              }else{
                if (pdfData.typeofconvertpdf===6){
                  firstPage.drawImage(signatureImage, {
                    x: 350, // Ajusta la posición X
                    y: 35, // Ajusta la posición Y
                    width:  100, // Ajusta el ancho de la firma
                    height: 50  // Ajusta la altura de la firma
                  }); 
                }else{
                  secondPage.drawImage(signatureImage, {
                    x: 250, // Ajusta la posición X
                    y: coordinates.ycoordsignaturerefund ?? 340, // Ajusta la posición Y
                    width: 70, // Ajusta el ancho de la firma
                    height: coordinates.ycoordsignaturerefund != null ? 22 : 40  // Ajusta la altura de la firma
                  }); 
                }                  
                
              }  
            }
          }   
        } 
      } 

      if (pdfData.typeofconvertpdf===2 ||pdfData.typeofconvertpdf===5){
        //LICENSE PLATE
        if (pdfData.licenseplate && pdfData.typeofconvertpdf===5 && pdfData.ycoord_licenseplate!==0) {
          let coordY = pdfData.ycoord_licenseplate;
          let coordX = 415; 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 85, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          firstPage.drawText(`${pdfData.licenseplate.substring(0, 30)}`, {
            x: coordX,
            y: coordY,  // Posición Y en la página 134F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        }  
         //AMOUNT
        if ( pdfData.amount!=null && pdfData.ycoord_amount!==0) {
          if (pdfData.typeofconvertpdf===5){
            let coordX = 95;
            let coordY = pdfData.ycoord_amount; 
            firstPage.drawRectangle({
              x: coordX,
              y: coordY - 2, // ajusta ligeramente para cubrir bien
              width: 60, // ajusta según la longitud esperada del texto
              height: 10,  // ajusta según el tamaño de fuente
              color: pdfData.typeofconvertpdf===3?rgb(1, 1, 0.6):rgb(1, 1, 1),
            });
            let amount = formatNumberWithKg(pdfData.amount);
            firstPage.drawText(`${amount}`, {
                x: coordX,  // Posición X en la página 322F
                y: coordY,  // Posición Y en la página 425F
                size: 8, // Tamaño de la fuente
                color: rgb(0, 0, 0), // Color negro
            });
          }else{
            let coordX = 131;
            let coordY = pdfData.ycoord_amount; 
            secondPage.drawRectangle({
              x: coordX,
              y: coordY - 2, // ajusta ligeramente para cubrir bien
              width: 60, // ajusta según la longitud esperada del texto
              height: 10,  // ajusta según el tamaño de fuente
              color: pdfData.typeofconvertpdf===3?rgb(1, 1, 0.6):rgb(1, 1, 1),
            });
            let amount = formatNumberWithKg(pdfData.amount);
            secondPage.drawText(`${amount}`, {
                x: coordX,  // Posición X en la página 322F
                y: coordY,  // Posición Y en la página 425F
                size: 8, // Tamaño de la fuente
                color: rgb(0, 0, 0), // Color negro
            });
          }
       
        }    
        //ACCEPT
        if (pdfData.ycoord_accept!==0) {
          if (pdfData.typeofconvertpdf===2){
            let coordY = pdfData.ycoord_accept;  
            let coordXAccept=507; 
      
            secondPage.drawRectangle({
              x: coordXAccept-1.5,
              y: coordY - 2, // ajusta ligeramente para cubrir bien
              width: 20, // ajusta según la longitud esperada del texto
              height: 10,  // ajusta según el tamaño de fuente
              color: rgb(1, 1, 1),
            });
            secondPage.drawEllipse({
              x: coordXAccept + 4,
              y: coordY + 2,
              xScale: 4, // Radio horizontal (la mitad del ancho total)
              yScale: 4, // Radio vertical (la mitad del alto total)
              color: rgb(1, 1, 1), // Relleno blanco
              borderColor: rgb(0, 0, 0), // Borde negro
              borderWidth: 1,
            });
            secondPage.drawRectangle({
              x: coordXAccept+40,
              y: coordY - 2, // ajusta ligeramente para cubrir bien
              width: 20, // ajusta según la longitud esperada del texto
              height: 10,  // ajusta según el tamaño de fuente
              color: rgb(1, 1, 1),
            });
            secondPage.drawEllipse({
              x: coordXAccept + 48,
              y: coordY + 2,
              xScale: 4, // Radio horizontal (la mitad del ancho total)
              yScale: 4, // Radio vertical (la mitad del alto total)
              color: rgb(1, 1, 1), // Relleno blanco
              borderColor: rgb(0, 0, 0), // Borde negro
              borderWidth: 1,
            });
            secondPage.drawText(`X`, {
              x: pdfData.accept==='Text_FORM_IsAccept'?coordXAccept+2:coordXAccept+45,  // Posición X en la página 195F
              y: coordY-1,  // Posición Y en la página 156F
              size: 8, // Tamaño de la fuente
              color: rgb(0, 0, 0), // Color negro
            });
          }else{
            let coordY = pdfData.ycoord_accept; 
            let coordXAccept=473; 
            let coordXNotAccept=523; 
            secondPage.drawRectangle({
              x: coordXAccept - 16,
              y: coordY - 6, // ajusta ligeramente para cubrir bien
              width: 30, // ajusta según la longitud esperada del texto
              height: 16,  // ajusta según el tamaño de fuente
              color: rgb(1, 1, 1),
            });
            secondPage.drawRectangle({
              x: coordXAccept - 2,
              y: coordY - 4, // Ajusta ligeramente para cubrir bien
              width: 10,
              height: 10,
              color: rgb(1, 1, 1), // Relleno blanco
              borderColor: rgb(0, 0, 0), // Borde negro
              borderWidth: 1, // Grosor del borde
            });     
           
            secondPage.drawRectangle({
              x: coordXNotAccept - 16,
              y: coordY - 6, // ajusta ligeramente para cubrir bien
              width: 30, // ajusta según la longitud esperada del texto
              height: 16,  // ajusta según el tamaño de fuente
              color: rgb(1, 1, 1),
            });
            secondPage.drawRectangle({
              x: coordXNotAccept - 2,
              y: coordY - 4, // Ajusta ligeramente para cubrir bien
              width: 10,
              height: 10,
              color: rgb(1, 1, 1), // Relleno blanco
              borderColor: rgb(0, 0, 0), // Borde negro
              borderWidth: 1, // Grosor del borde
            });             
            secondPage.drawText(`X`, {
              x: pdfData.accept==='Text_FORM_IsAccept'?coordXAccept:coordXNotAccept,  // Posición X en la página 195F
              y: coordY-1,  // Posición Y en la página 156F
              size: 8, // Tamaño de la fuente
              color: rgb(0, 0, 0), // Color negro
            });
          }
        } 
       
        // DELIVERY DATE
        if (pdfData.deliver_date && pdfData.ycoord_deliver_date!==0) {
       
          let deliver_date = getDateFormated(pdfData.deliver_date);
          let coordX=pdfData.typeofconvertpdf===2?165:106;
          secondPage.drawRectangle({
            x: coordX,
            y: pdfData.typeofconvertpdf===2?pdfData.ycoord_delivery_quantity-2:pdfData.ycoord_deliver_date- 2, // ajusta ligeramente para cubrir bien
            width: 50, // ajusta según la longitud esperada del texto
            height: 10,  // ajusta según el tamaño de fuente
            color: rgb(1, 1, 1), // blanco
          });
          secondPage.drawText(`${deliver_date}`, {
            x: coordX,  
            y: pdfData.typeofconvertpdf===2?pdfData.ycoord_delivery_quantity:pdfData.ycoord_deliver_date,  // Posición Y en la página 166F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          }); 
        }   
        //DELIVERY QUANTITY 
       
         if (pdfData.delivery_quantity!=null && pdfData.ycoord_delivery_quantity!==0) {
          let coordX=pdfData.typeofconvertpdf===2?350:412;
          secondPage.drawRectangle({
            x: coordX,
            y: pdfData.ycoord_delivery_quantity - 2, // ajusta ligeramente para cubrir bien
            width: 50, // ajusta según la longitud esperada del texto
            height: 10,  // ajusta según el tamaño de fuente
            color: rgb(1, 1, 1), // blanco
          });  
          let delivery_quantity = formatNumberWithKg(pdfData.delivery_quantity);
          secondPage.drawText(`${delivery_quantity}`, {
            x: coordX,  
            y: pdfData.ycoord_delivery_quantity,  // Posición Y en la página 166F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          }); 
        }   
        // DATE ACCEPT
        if (pdfData.ycoord_date_accepted!==0) {
          let date_accepted = getDateFormated(pdfData.date_accepted) ;
          let coordX=pdfData.typeofconvertpdf===2?165:106;
          secondPage.drawRectangle({
            x: coordX,
            y: pdfData.ycoord_date_accepted - 2, // ajusta ligeramente para cubrir bien
            width: 50, // ajusta según la longitud esperada del texto
            height: 10,  // ajusta según el tamaño de fuente
            color: rgb(1, 1, 1), // blanco
          }); 
          secondPage.drawText(`${date_accepted}`, {
            x: coordX,  
            y: pdfData.ycoord_date_accepted,  // Posición Y en la página 156F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        }
         // ACTION 
        if (pdfData.ycoord_action_refund!==0) {
          let coordX=pdfData.typeofconvertpdf===2?165:140;
          secondPage.drawRectangle({
            x: coordX,
            y: pdfData.ycoord_action_refund - 2, // ajusta ligeramente para cubrir bien
            width: pdfData.ycoord_action_refund===2?200:400, // ajusta según la longitud esperada del texto
            height: 10,  // ajusta según el tamaño de fuente
            color: rgb(1, 1, 1), // blanco
          }); 
          secondPage.drawText(`${pdfData.action_refund}`, {
            x: coordX,  
            y: pdfData.ycoord_action_refund,  // Posición Y en la página 156F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        }  
         // DATE REFUND 
        if (pdfData.ycoord_date_refund!==0) {
          let date_refund = getDateFormated(pdfData.date_refund);
          let coordX=pdfData.typeofconvertpdf===2?165:140;
          secondPage.drawRectangle({
            x: coordX,
            y: pdfData.ycoord_date_refund - 2, // ajusta ligeramente para cubrir bien
            width: 150, // ajusta según la longitud esperada del texto
            height: 10,  // ajusta según el tamaño de fuente
            color: rgb(1, 1, 1), // blanco
          }); 
          secondPage.drawText(`${date_refund}`, {
            x: coordX,  
            y: pdfData.ycoord_date_refund,  // Posición Y en la página 156F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        }
      
        // REASON 
        if (pdfData.ycoord_reason_refund!==0) {
          let coordX=pdfData.typeofconvertpdf===2?165:110;
          secondPage.drawRectangle({
            x: coordX,
            y: pdfData.ycoord_reason_refund - 2, // ajusta ligeramente para cubrir bien
            width: 400, // ajusta según la longitud esperada del texto
            height: 10,  // ajusta según el tamaño de fuente
            color: rgb(1, 1, 1), // blanco
          }); 
          secondPage.drawText(`${pdfData.reason_refund}`, {
            x: coordX,  
            y: pdfData.ycoord_reason_refund,  // Posición Y en la página 156F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          }); 
        }    
      } else{
        //LICENSE PLATE 
        if (pdfData.licenseplate && pdfData.ycoord_licenseplate!==0) {
          let coordX = pdfData.xcoord_licenseplate;
          let coordY = pdfData.ycoord_licenseplate; 
          switch (pdfData.typeofconvertpdf) {
            case 1:
                coordX=420.5;
                break;
            case 2:
                break;
            case 3:
                coordY=coordY-2;
                coordX=400;
                break;
            default:
                break;
          }
       
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 85, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          firstPage.drawText(`${pdfData.licenseplate.substring(0, 30)}`, {
            x: coordX,
            y: coordY,  // Posición Y en la página 134F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        }  
      
        //ACCEPT
        if (pdfData.accept && pdfData.ycoord_accept!==0) {
          let coordX = pdfData.xcoord_accept;
          let coordY = pdfData.ycoord_accept; 
          switch (pdfData.typeofconvertpdf) {
            case 1:
                coordX=190;
                break;
            case 3:
                coordY=93;
                coordX=400;
                break;
            default:
                break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 100, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3 || pdfData.typeofconvertpdf===6?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          firstPage.drawText(`${t(pdfData.accept)}`, {
            x: coordX,  // Posición X en la página 195F
            y: coordY,  // Posición Y en la página 156F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          }); 
        }  
        //AMOUNT
        if (enabledAmount && pdfData.amount!=null && pdfData.ycoord_amount!==0) {
          let coordX = pdfData.xcoord_amount;
          let coordY = pdfData.ycoord_amount; 
          switch (pdfData.typeofconvertpdf) {
            case 1:
                coordX=422;
                break;
            case 3: 
                coordX=206;
                break; 
            default:
                break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 60, // ajusta según la longitud esperada del texto
            height: 10,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3  || pdfData.typeofconvertpdf===6?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          let amount = formatNumberWithKg(pdfData.amount);
          firstPage.drawText(`${amount}`, {
              x: coordX,  // Posición X en la página 322F
              y: coordY,  // Posición Y en la página 425F
              size: 8, // Tamaño de la fuente
              color: rgb(0, 0, 0), // Color negro
          });
        }    
        //DELIVERY QUANTITY 
         if (pdfData.delivery_quantity!=null && pdfData.ycoord_delivery_quantity!==0) {
          let coordX = pdfData.xcoord_delivery_quantity;
          let coordY = pdfData.ycoord_delivery_quantity; 
          switch (pdfData.typeofconvertpdf) {
            case 1:
                coordX=422;
                break;
            case 3: 
                coordX=328;
                break; 
            default:
                break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 57, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3 || pdfData.typeofconvertpdf===6?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          let delivery_quantity = formatNumberWithKg(pdfData.delivery_quantity);
          firstPage.drawText(`${delivery_quantity}`, {
              x: coordX,  // Posición X en la página 425F
              y: coordY,  // Posición Y en la página 166F
              size: 8, // Tamaño de la fuente
              color: rgb(0, 0, 0), // Color negro
          });
        }
        // DELIVERY DATE
        if ( pdfData.ycoord_deliver_date!==0) {
          let coordX = pdfData.xcoord_deliver_date;
          let coordY = pdfData.ycoord_deliver_date; 
          switch (pdfData.typeofconvertpdf) {
            case 1:
              coordX=177;
              break;
            case 3: 
              coordX=152;
              break; 
            default:
                break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 55, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3 || pdfData.typeofconvertpdf===6?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          let deliver_date = getDateFormated(pdfData.deliver_date);
          firstPage.drawText(`${deliver_date}`, {
              x:coordX,  // Posición X en la página 180F
              y: coordY,  // Posición Y en la página 166F
              size: 8, // Tamaño de la fuente
              color: rgb(0, 0, 0), // Color negro
          });
        }
        // DATE ACCEPT
        if (pdfData.ycoord_date_accepted!==0) {
          let coordX = pdfData.xcoord_date_accepted;
          let coordY = pdfData.ycoord_date_accepted; 
          switch (pdfData.typeofconvertpdf) {
            case 1:
                coordX=411;
                break;
            case 3: 
                coordX=152;
                break; 
            default:
                break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 55, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3 || pdfData.typeofconvertpdf===6?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          let date_accepted = getDateFormated(pdfData.date_accepted);
          firstPage.drawText(`${date_accepted}`, {
              x: coordX,  // Posición X en la página 415F
              y: coordY,  // Posición Y en la página 156F
              size: 8, // Tamaño de la fuente
              color: rgb(0, 0, 0), // Color negro
          });
        }
        // REASON 
        if (pdfData.typeofconvertpdf!==1 && pdfData.ycoord_reason_refund!==0) {
          let coordX = pdfData.xcoord_reason_refund;
          let coordY = pdfData.ycoord_reason_refund; 
          switch (pdfData.typeofconvertpdf) {
            case 3: 
              coordY=82;
              coordX=328;
              break;
            default:
                break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 222, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3 || pdfData.typeofconvertpdf===6 ?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          firstPage.drawText(`${pdfData.reason_refund.substring(0, 70)}`, {
            x: coordX,
            y: coordY,  // Posición Y en la página 156F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        }   
        // ACTION  
        if (pdfData.typeofconvertpdf!==1 && pdfData.ycoord_action_refund!==0) {
          let coordX = pdfData.xcoord_action_refund;
          let coordY = pdfData.ycoord_action_refund; 
          switch (pdfData.typeofconvertpdf) {
            case 3: 
              coordX=152;
              break;
            default:
              break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: pdfData.typeofconvertpdf===3?100:170, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3 || pdfData.typeofconvertpdf===6?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          firstPage.drawText(`${pdfData.action_refund.substring(0, 35)}`, {
            x: coordX,
            y: coordY,  // Posición Y en la página 156F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        }
        // DATE REFUND  
        if (pdfData.typeofconvertpdf!==1  && pdfData.ycoord_date_refund!==0) {
          let coordX = pdfData.xcoord_date_refund;
          let coordY = pdfData.ycoord_date_refund; 
          switch (pdfData.typeofconvertpdf) {
            case 3: 
              coordY=72;
              coordX=350;
              break;
            default:
              break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 55, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: pdfData.typeofconvertpdf===3 || pdfData.typeofconvertpdf===6?rgb(1, 1, 0.6):rgb(1, 1, 1),
          });
          let date_refund = getDateFormated(pdfData.date_refund);
          firstPage.drawText(`${date_refund}`, {
            x: coordX,
            y: coordY,  // Posición Y en la página 156F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        }
        // OBSERVATIONS
        if (pdfData.typeofconvertpdf!==4 && pdfData.ycoord_observations!==0) {
          let coordX = pdfData.xcoord_observations;
          let coordY = pdfData.ycoord_observations; 
          switch (pdfData.typeofconvertpdf) {
            case 3: 
              coordX=125;
              break;
            default:
              break;
          } 
          firstPage.drawRectangle({
            x: coordX,
            y: coordY - 2, // ajusta ligeramente para cubrir bien
            width: 394, // ajusta según la longitud esperada del texto
            height: 9,  // ajusta según el tamaño de fuente
            color: rgb(1, 1, 1), // blanco
          });
          firstPage.drawText(`${pdfData.observations.substring(0, 120)}`, {
            x: coordX,  // Posición X en la página 130F
            y: coordY,  // Posición Y en la página 134F
            size: 8, // Tamaño de la fuente
            color: rgb(0, 0, 0), // Color negro
          });
        } 
      }
      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
      const newPdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(newPdfUrl); // Actualiza el `iframe`
      // Convertir el Blob en Base64
      const convertBlobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => resolve(reader.result.split(',')[1]); // Tomamos solo el Base64
          reader.onerror = (error) => reject(error);
        });
      };
      const pdfBase64 = await convertBlobToBase64(pdfBlob);
      setDataFormDISignature(prevData => ({
        ...prevData,
        ...coordinates,
        pdfUrl: pdfBase64 // Enviar el contenido en Base64 en lugar de una URL blob
      }));   
    } catch (error) { 
      dispatch(warningErrorAction(t('Text_IncorrectData'))); 
    }
  };

  const handleBlurDataEditFormAmount = (e) => {
    handleChangeDataEditFormAmount(e);
    setErrorsFormDISignature(validateFormDISiganture());
  };

  const handleChangeDataEditFormAmount = (e) => {
    const { name, value } = e.target;
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" Kg","")):0;
    setDataFormDISignature(dataFormDISignature => ({
      ...dataFormDISignature,
      [name]: newValue,
    }));
  };

  const handleBlurDataEditForm = (e) => {
    handleChangeDataEditForm(e);
    setErrorsFormDISignature(validateFormDISiganture());
  };

  const handleChangeDataEditForm = (e) => {
    const { name, value } = e.target;
    setDataFormDISignature(dataFormDISignature => ({
      ...dataFormDISignature,
      [name]: value,
    }));
  };

  const handleBlurSelectAccepted = (e) => {
    handleChangeSelectAccepted(e);
    setErrorsFormDISignature(validateFormDISiganture());
  };

  const handleChangeSelectAccepted = (event) => {
    setDataFormDISignature(dataFormDISignature => ({
        ...dataFormDISignature,
        accept : event.target.value 
    }));
  };

  const handleBlurSelectDateAccepted = (e) => {
    handleChangeSelectDateAccepted(e);
    setErrorsFormDISignature(validateFormDISiganture());
  };

  const handleChangeSelectDateAccepted = (event) => {
    setDataFormDISignature(dataFormDISignature => ({
      ...dataFormDISignature,
      date_accepted: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateDeliver = (e) => {
    handleChangeSelectDateDeliver(e);
    setErrorsFormDISignature(validateFormDISiganture());
  };

  const handleChangeSelectDateDeliver = (event) => {
    setDataFormDISignature(dataFormDISignature => ({
      ...dataFormDISignature,
      deliver_date: event!==null?new Date(event):null
    }));
  };

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000000) return true;
    return false;
  };

  const handleBlurSelectDateRefund = (e) => {
    handleChangeSelectDateRefund(e);
    setErrorsFormDISignature(validateFormDISiganture());
  };

  const handleChangeSelectDateRefund = (event) => {
    setDataFormDISignature(dataFormDISignature => ({
      ...dataFormDISignature,
      date_refund: event!==null?new Date(event):null
    }));
  };
    
  const validateFormDISiganture = () => {
    let errorsFormDISignature = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
     
        
    if (regexInvalidCharacters.test(dataFormDISignature.reason_refund)) {
      errorsFormDISignature.reason_refund = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(dataFormDISignature.action_refund)) {
      errorsFormDISignature.action_refund = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(dataFormDISignature.observations)) {
      errorsFormDISignature.observations = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(dataFormDISignature.licenseplate)) {
      errorsFormDISignature.licenseplate = 'Text_TextNoValid';
    }
    return errorsFormDISignature;
  };

  const handleConfirmFetchDataEditForm = (dataToSend) => {  
    let isMounted = true;
    const fetchData = async () => { 
      try {
        const getData =  await helpHttp().put(ENDPOINT, `form/updateformdisignature`, token, dataToSend);
        if (getData.status === "OK") { 
          dispatch(successErrorAction(t('Text_SaveData'))); 
        } else {
          if (isMounted ) {
            dispatch(warningErrorAction(t(getData.cause)));
          }
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    fetchData();
    handleCloseDataEditFormDISignature();
    return () => { isMounted = false };
  };
  
  const handleSubmitDataEditFormSignature = () => {
    const errors = validateFormDISiganture();
    setErrorsFormDISignature(errors);
    if (Object.keys(errors).length === 0 && dataFormDISignature.pdfUrl!=="") {  
      let signatureOpt_tras = dataFormDISignature.signature_opt_tras;
      let signatureDest_tras = dataFormDISignature.signature_dest_tras;
      let signature_refund = dataFormDISignature.signature_refund;
      if (signDispatchedOptTrasCanvas.current && !signDispatchedOptTrasCanvas.current.isEmpty()) {
        signatureOpt_tras = signDispatchedOptTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }

      if (signDispatchedDestTrasCanvas.current && !signDispatchedDestTrasCanvas.current.isEmpty()) {
        signatureDest_tras = signDispatchedDestTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
      if (signDispatchedRefundCanvas.current && !signDispatchedRefundCanvas.current.isEmpty()) {
        signature_refund = signDispatchedRefundCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
      const formToSend = {
        ...dataFormDISignature,
        signature_opt_tras: signatureOpt_tras,
        signature_dest_tras: signatureDest_tras,
        signature_refund: signature_refund
      };
      setDataFormDISignature(dataFormDISignature => ({
        ...dataFormDISignature,
        signature_opt_tras: signatureOpt_tras,
        signature_dest_tras: signatureDest_tras,
        signature_refund: signature_refund
      }));
      handleConfirmFetchDataEditForm(formToSend);    
    } else { 
      if (errorsFormDISignature.reason_refund) {
        dispatch(warningErrorAction(t(errorsFormDISignature.reason_refund)));
      } else if (errorsFormDISignature.action_refund) {
        dispatch(warningErrorAction(t(errorsFormDISignature.action_refund)));
      } else if (errorsFormDISignature.observations) {
        dispatch(warningErrorAction(t(errorsFormDISignature.observations)));
      } else if (errorsFormDISignature.licenseplate) {
        dispatch(warningErrorAction(t(errorsFormDISignature.licenseplate)));
      } else if (dataFormDISignature.pdfUrl==="") {
        dispatch(warningErrorAction(t('Text_NOT_INSERTED')));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      } 
    }
  };
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  const isValidPngDataURL = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (trimmed==="") return false;
    if (trimmed.includes("static/media")) return true; 
    if (!trimmed.startsWith("data:image/png;base64,")) return false;
    // longitud mínima razonable para un PNG (ajusta si quieres)
    return trimmed.length > 200; 
  };

  useEffect(() => {
    let isMounted = true;
    const fetchFileForm = async (fileName) => {
      try {
        const getData = await helpHttp().getfilesupload(ENDPOINT, `pdftos3uploader/downloadfroms3`, token,fileName);
        if (!getData) {
          setPdfUrl("");
          setOriginalPdfUrl("");
          dispatch(warningErrorAction(t('Text_ConnectionFailed'))); 
        } else{
          if (getData && getData.size>0){
            const url = URL.createObjectURL(getData);
            setPdfUrl(url); // Guardar la URL del PDF para mostrarlo en <iframe>
            setOriginalPdfUrl(url); 
          }
        }
      } catch (error) {
        setPdfUrl("");
        setOriginalPdfUrl("");
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataForm = async () => {
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`form/getformdisignaturebyid/`,token,id);
        if (getData.err) {
          setDataFormDISignature(initialStateForm);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailed' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataFormDISignature(getData);
          if (getData.signature_opt_tras && isValidPngDataURL(getData.signature_opt_tras)) {
            setTimeout(() => {
              if (signDispatchedOptTrasCanvas.current) {
                drawSignatureCentered(signDispatchedOptTrasCanvas, getData.signature_opt_tras);
              }
            }, 200);
          }  
          if (getData.signature_dest_tras && isValidPngDataURL(getData.signature_dest_tras)) {
            setTimeout(() => {
              if (signDispatchedDestTrasCanvas.current) {
                drawSignatureCentered(signDispatchedDestTrasCanvas, getData.signature_dest_tras);
              }
            }, 200);
          }   
          if (getData.signature_refund && isValidPngDataURL(getData.signature_refund)) {
            setTimeout(() => {
              if (signDispatchedRefundCanvas.current) {
                drawSignatureCentered(signDispatchedRefundCanvas, getData.signature_refund);
              }
            }, 200);
          }    
          if (getData.amount!==0){
            setEnabledAmount(false);
          }   
          if (getData.signature_opt_tras==="" && (getData.typeofconvertpdf===4 || getData.typeofconvertpdf===3)){
            setSharedsignOptTras(false); 
          } else{
            setSharedsignOptTras(true); 
          }  
          if (getData.signature_dest_tras!==""){
            setSharedsignDestTras(true); 
          } else{
            setSharedsignDestTras(false); 
          }
          if (getData.signature_refund!==""){
            setSharedsignRefund(true); 
          } else{
            setSharedsignRefund(false); 
          }
          if (getData && getData.numberDI_sheet && getData.numberDI_sheet!==""){
            fetchFileForm(await resolveDiPdfFilename(ENDPOINT,token,getData.id)); 
          }
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    }; 
    if (id!=="0"){
      if (dataFormDISignature.id==="" || dataFormDISignature.id===0){ 
        fetchDataForm();
      } 
    }else{
      setDataFormDISignature(initialStateForm);  

    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,dataFormDISignature.id,defaulttypesdi,showModalFormDISignature]);  
 
   return (
    <>
      {showModalFormDISignature ? ( 
        <div className="container-fluid email-send-wrapper">
          <Box sx={{ bgcolor: '#ffffff', width: '1840px'}}>
            <form className="createform" onSubmit={handleCloseDataEditFormDISignature}>  
               {/* HEADER */}
              <div className="formgeneral-card-header">
                <div className="formgeneral-header-content">
                  <div className="formgeneral-header-title2">
                    {isLoadingErrorData?
                      <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                      (isLoadingData?
                      <CircularProgress sx={{ color : "#f6c23e"}}/>:
                      <i className="fas fa-regular fa-clipboard text-warning"></i>)} 
                      &nbsp;&nbsp;{t('Text_FORM_Line1')}
                  </div>
                  <div className="email-card-actions">
                    {!isLoadingData && (
                      <>
                        <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditFormSignature} >
                          {t('Button_Update')}
                        </button>
                        <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditFormDISignature} >
                          {t('Button_Cancel')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <br/>
            
              {/* FORM CARD */}
              {!isLoadingData ?
              <>   
                <div className="signature-layout">
                  <div className="signature-form">
                    <div className="email-card-form">
                      <div className="row p-4">
                        <div className="email-card-title2">
                          <h3 className="mb-3 fw-bold" style={{ color:"#df974e", fontSize: 28 }}>
                            {t("Text_FORM_NUM_DI")+': '+dataFormDISignature.numberDI_sheet}
                          </h3>
                        </div> 

                        <div className="row p-2"> 
                          <div className="form-group">
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Vehicle_licenseplate')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id="licenseplate" 
                              name="licenseplate"
                              value={dataFormDISignature.licenseplate}
                              inputProps={{ style: {width: i18n.language==='es'?300:300}, maxLength: 30  }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFormDISignature.licenseplate!=null?t(errorsFormDISignature.licenseplate):t('PlaceHolder_FORM_Vehicles')}
                              placeholder={t('PlaceHolder_FORM_Vehicles')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                              disabled={ pdfUrl==="" }
                            />
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_AMOUNT')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <NumericFormat 
                              thousandSeparator={','} 
                              decimalSeparator={'.'} 
                              decimalScale= {2}
                              fixedDecimalScale= {true}
                              allowNegative= {false}
                              isAllowed={withValueCap}
                              id="amount" 
                              name="amount"
                              suffix={" Kg"}
                              value={dataFormDISignature.amount}
                              label={errorsFormDISignature.amount!=null?t(errorsFormDISignature.amount):t('Text_FORM_AMOUNT')}
                              placeholder={t('PlaceHolder_FORM_AMOUNT')}
                              inputProps={{ style: {width: i18n.language==='es'?200:200} }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              customInput={TextField}
                              onBlur={handleBlurDataEditFormAmount}
                              onChange={handleChangeDataEditFormAmount}
                              disabled={!enabledAmount || pdfUrl==="" }
                            />
                          </div>
                        </div>
                        <div className="row p-2"> 
                          <div className="form-group">   
                            <h6 className="h7NewStyle mb-2">{t('Text_FORM_ACCEPTED')}</h6>
                            {/* Divider */}
                            <hr className="sidebar-divider d-none d-md-block"/>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Deliver_date')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <DesktopDatePicker
                                id="deliver_date" 
                                name="deliver_date"
                                value={ dataFormDISignature.deliver_date!== null ? new Date(dataFormDISignature.deliver_date): null}
                                label={errorsFormDISignature.deliver_date!=null?t(errorsFormDISignature.deliver_date):t('Text_FORM_Deliver_date')}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                onBlur={handleBlurSelectDateDeliver}
                                onChange={handleChangeSelectDateDeliver}
                                disabled={pdfUrl==="" }
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                    sx: {
                                      maxLength: 200,
                                      width: i18n.language==="es"?200:250,
                                      fontSize: '18px',  
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Delivery_quantity')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <NumericFormat 
                              thousandSeparator={','} 
                              decimalSeparator={'.'} 
                              decimalScale= {2}
                              fixedDecimalScale= {true}
                              allowNegative= {false}
                              isAllowed={withValueCap}
                              id="delivery_quantity" 
                              name="delivery_quantity"
                              value={dataFormDISignature.delivery_quantity}
                              label={errorsFormDISignature.delivery_quantity!=null?t(errorsFormDISignature.delivery_quantity):t('Text_FORM_Delivery_quantity')}
                              placeholder={t('Text_FORM_Delivery_quantity')}
                              inputProps={{ style: {width: i18n.language==='es'?222:268} }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              customInput={TextField}
                              onBlur={handleBlurDataEditFormAmount}
                              onChange={handleChangeDataEditFormAmount}
                              disabled={ pdfUrl==="" }
                            />
                          </div>
                        </div> 
                        <div className="row p-2"> 
                          <div className="form-group">   
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Accept')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id="accept"
                              name="accept"
                              value={ (dataFormDISignature.accept === undefined || dataFormDISignature.accept ===null || dataFormDISignature.accept ==="")?t("Text_NOT_REPORTING"):dataFormDISignature.accept}
                              inputProps={{ style: {width: i18n.language==='es'?180:207} }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              variant="outlined"
                              onBlur={handleBlurSelectAccepted}
                              onChange={handleChangeSelectAccepted} 
                              helperText={errorsFormDISignature.accept!=null?t(errorsFormDISignature.accept):""}
                              select
                              SelectProps={{
                                  native: true,
                                  value: (dataFormDISignature.accept === undefined || dataFormDISignature.accept ===null || dataFormDISignature.accept ==="")?t("Text_NOT_REPORTING"): dataFormDISignature.accept
                              }}>
                              <option key={0} value=""/>
                              {textAccepted.map((option) => (
                                  <option key={option.id} value={option.name}>
                                      {t(option.name)}
                                  </option>
                              ))}
                            </TextField>  
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Date_Accepted')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <DesktopDatePicker
                                id="date_accepted" 
                                name="date_accepted"
                                value={ dataFormDISignature.date_accepted!== null ? new Date(dataFormDISignature.date_accepted): null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                label={errorsFormDISignature.date_accepted!=null?t(errorsFormDISignature.date_accepted):t('Text_FORM_Date_Accepted')}
                                onBlur={handleBlurSelectDateAccepted}
                                onChange={handleChangeSelectDateAccepted}
                                disabled={ pdfUrl==="" }
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                    sx: {
                                      maxLength: 200,
                                      width: 200,
                                      fontSize: '18px',  
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </div>
                        </div> 
                        {(reason_refund_view && dataFormDISignature.typeofconvertpdf!==1)  && 
                          <div className="row p-2"> 
                            <div className="form-group">
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Reason_Refund')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp; 
                              <TextField
                                id="reason_refund" 
                                name="reason_refund"
                                value={dataFormDISignature.reason_refund}
                                inputProps={{ style: {width: i18n.language==='es'?696:683}, maxLength: 100  }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={errorsFormDISignature.reason_refund!=null?t(errorsFormDISignature.reason_refund):t('PlaceHolder_FORM_Reason_Refund')}
                                placeholder={t('PlaceHolder_FORM_Reason_Refund')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm}
                                onChange={handleChangeDataEditForm}
                                disabled={!reason_refund_handle || pdfUrl==="" }/>
                            </div>
                          </div> 
                        } 
                        {((action_refund_view || date_refund_view) && dataFormDISignature.typeofconvertpdf!==1) && 
                          <div className="row p-2">  
                            {action_refund_view && 
                              <div className="form-group">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Action_Refund')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="action_refund" 
                                  name="action_refund"
                                  value={dataFormDISignature.action_refund}
                                  inputProps={{ style: {width: i18n.language==='es'?190:248}, maxLength: 100  }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  label={errorsFormDISignature.action_refund!=null?t(errorsFormDISignature.action_refund):t('PlaceHolder_FORM_Action_Refund')}
                                  placeholder={t('PlaceHolder_FORM_Action_Refund')}
                                  variant="standard"
                                  onBlur={handleBlurDataEditForm}
                                  onChange={handleChangeDataEditForm} 
                                  disabled={!action_refund_handle || pdfUrl==="" }
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                              </div> 
                            }
                            {date_refund_view && 
                              <div className="form-group"> 
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                  <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Refund')} :</label>
                                  &nbsp;&nbsp;&nbsp;&nbsp; 
                                  <DesktopDatePicker
                                    id="date_refund" 
                                    name="date_refund"
                                    value={ dataFormDISignature.date_refund!== null ? new Date(dataFormDISignature.date_refund): null}
                                    format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                    label={errorsFormDISignature.date_refund!=null?t(errorsFormDISignature.date_refund):t('Text_FORM_Refund')}
                                    onBlur={handleBlurSelectDateRefund}
                                    onChange={handleChangeSelectDateRefund} 
                                    disabled={!date_refund_handle || pdfUrl==="" }
                                    slotProps={{
                                      textField: {
                                        placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                        sx: {
                                          maxLength: 200,
                                          width: i18n.language==="es"?200:200,
                                          fontSize: '18px',  
                                        },
                                        InputProps: {
                                          style: {
                                            fontSize: '18px',
                                          }
                                        },
                                        InputLabelProps:{ 
                                          style: {
                                            fontSize: '18px', 
                                            background: '#FFFFFF'
                                          }
                                        },
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </div> 
                            }
                          </div> 
                        }  
                        <div className="row p-2"> 
                          <div className="form-group">   
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Observations')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id="observations" 
                              name="observations"
                              value={dataFormDISignature.observations}
                              inputProps={{ style: {width: i18n.language==='es'?705:719}, maxLength: 250  }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFormDISignature.observations!=null?t(errorsFormDISignature.observations):t('PlaceHolder_FORM_Observations')}
                              placeholder={t('PlaceHolder_FORM_Observations')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                              disabled={pdfUrl==="" }
                            />
                          </div>
                        </div>
                        <br/>
                        <div className="signature-section">
                          <Grid container spacing={2} justifyContent="space-around" alignItems="stretch">
                            {/* === FIRMA OPERADOR TRASLADO === */}
                            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", justifyContent: "center" }} key="sig-1">
                              <Card className="signature-card">
                                <CardContent className="signature-card-content">
                                  {/* Canvas (fila 1, col 1) */}
                                   <div className={`signature-canvas ${sharedsignOptTras ? "signature-canvas--disabled" : ""}`}>
                                    <SignatureCanvas
                                      penColor="black"
                                      ref={signDispatchedOptTrasCanvas}
                                      canvasProps={{
                                        width: CANVAS_SIZE,
                                        height: CANVAS_SIZE,
                                        style: {
                                          width: `${CANVAS_SIZE}px`,
                                          height: `${CANVAS_SIZE}px`,
                                          display: "block"
                                        }
                                      }}
                                    /> 
                                  </div>   
                                  {/* Columna lateral (col 2, filas 1-2) */}
                                  <Box className="signature-side-col">
                                    <Button className="signature-side-btn" disabled={sharedsignOptTras} onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[0]:predefinedSignaturesBentahor[0]) }>
                                     {TEXT_SIGN_1}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignOptTras} onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[1]:predefinedSignaturesBentahor[1]) }>
                                      {TEXT_SIGN_2}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignOptTras} onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[2]:predefinedSignaturesBentahor[2]) }>
                                      {TEXT_SIGN_3}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignOptTras} onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[3]:predefinedSignaturesBentahor[3]) }>
                                      {TEXT_SIGN_4}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignOptTras} onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[4]:predefinedSignaturesBentahor[4]) }>
                                      {TEXT_SIGN_5}
                                    </Button>
                                  </Box>

                                  {/* Botón ELIMINAR (fila 2, col 1) */}
                                  <div className="signature-delete">
                                    <Button
                                      className="signature-btn"
                                      size="small"
                                      disabled={sharedsignOptTras}
                                      onClick={() => deleteSignature(1)}
                                    >
                                      {t("Button_Delete")}
                                    </Button>
                                  </div>
                                </CardContent>

                                {/* Título debajo del botón eliminar */}
                                <Typography className="signature-title">
                                  {t("Text_Signature_Opt_Tras")}
                                </Typography>
                              </Card>
                            </Grid>

                            {/* === FIRMA DESTINO TRASLADO === */}
                            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", justifyContent: "center" }} key="sig-2">
                              <Card className="signature-card">
                                <CardContent className="signature-card-content">
                                  <div className={`signature-canvas ${sharedsignDestTras ? "signature-canvas--disabled" : ""}`}>
                                    <SignatureCanvas
                                      penColor="black"
                                      ref={signDispatchedDestTrasCanvas}
                                      canvasProps={{
                                        width: CANVAS_SIZE,
                                        height: CANVAS_SIZE,
                                        style: {
                                          width: `${CANVAS_SIZE}px`,
                                          height: `${CANVAS_SIZE}px`,
                                          display: "block"
                                        }
                                      }}
                                    /> 
                                  </div>  
                                  <Box className="signature-side-col">
                                    <Button className="signature-side-btn" disabled={sharedsignDestTras} onClick={() => drawPredefinedSignatureDestTras(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[0]:predefinedSignaturesBentahor[0]) }>
                                      {TEXT_SIGN_1}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignDestTras} onClick={() => drawPredefinedSignatureDestTras(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[1]:predefinedSignaturesBentahor[1]) }>
                                      {TEXT_SIGN_2}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignDestTras} onClick={() => drawPredefinedSignatureDestTras(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[2]:predefinedSignaturesBentahor[2]) }>
                                      {TEXT_SIGN_3}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignDestTras} onClick={() => drawPredefinedSignatureDestTras(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[3]:predefinedSignaturesBentahor[3]) }>
                                      {TEXT_SIGN_4}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignDestTras} onClick={() => drawPredefinedSignatureDestTras(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[4]:predefinedSignaturesBentahor[4]) }>
                                      {TEXT_SIGN_5}
                                    </Button>
                                  </Box>

                                  <div className="signature-delete">
                                    <Button
                                      className="signature-btn"
                                      size="small"
                                      disabled={sharedsignDestTras}
                                      onClick={() => deleteSignature(2)}
                                    >
                                      {t("Button_Delete")}
                                    </Button>
                                  </div>
                                </CardContent>

                                <Typography className="signature-title">
                                  {t("Text_Signature_Dest_Tras")}
                                </Typography>
                              </Card>
                            </Grid>

                            {/* === FIRMA RECHAZO DESTINO === */}
                            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", justifyContent: "center" }} key="sig-3">
                              <Card className="signature-card">
                                <CardContent className="signature-card-content">
                                  <div className={`signature-canvas ${sharedsignRefund ? "signature-canvas--disabled" : ""}`}>
                                    <SignatureCanvas
                                      penColor="black"
                                      ref={signDispatchedRefundCanvas}
                                      canvasProps={{
                                        width: CANVAS_SIZE,
                                        height: CANVAS_SIZE,
                                        style: {
                                          width: `${CANVAS_SIZE}px`,
                                          height: `${CANVAS_SIZE}px`,
                                          display: "block"
                                        }
                                      }}
                                    /> 
                                  </div>  
                                  <Box className="signature-side-col">
                                    <Button className="signature-side-btn" disabled={sharedsignRefund} onClick={() => drawPredefinedSignatureRefund(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[0]:predefinedSignaturesBentahor[0]) }>
                                      {TEXT_SIGN_1}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignRefund} onClick={() => drawPredefinedSignatureRefund(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[1]:predefinedSignaturesBentahor[1]) }>
                                      {TEXT_SIGN_2}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignRefund} onClick={() => drawPredefinedSignatureRefund(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[2]:predefinedSignaturesBentahor[2]) }>
                                      {TEXT_SIGN_3}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignRefund} onClick={() => drawPredefinedSignatureRefund(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[3]:predefinedSignaturesBentahor[3]) }>
                                      {TEXT_SIGN_4}
                                    </Button>
                                    <Button className="signature-side-btn" disabled={sharedsignRefund} onClick={() => drawPredefinedSignatureRefund(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[4]:predefinedSignaturesBentahor[4]) }>
                                      {TEXT_SIGN_5}
                                    </Button>
                                  </Box>
                                  <div className="signature-delete">
                                    <Button
                                      className="signature-btn"
                                      size="small"
                                      disabled={sharedsignRefund}
                                      onClick={() => deleteSignature(3)}
                                    >
                                      {t("Button_Delete")}
                                    </Button>
                                  </div>
                                </CardContent>

                                <Typography className="signature-title">
                                  {t("Text_Signature_Refund")}
                                </Typography>
                              </Card>
                            </Grid>
                          </Grid>

                          {/* BOTONES FINALES */}
                          <br />
                          <Grid container spacing={4} className="signature-actions-grid">
                            <Grid item xs={12} md={4}>
                              <button
                                type="button"
                                className="formgeneral-action-btn formgeneral-btn-cancel"
                                onClick={handleCloseDataEditFormDISignature}
                              >
                                {t("Button_Cancel_Sign")}
                              </button>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <button
                                type="button"
                                className="formgeneral-action-btn formgeneral-btn-delete"
                                disabled={pdfUrl === ""}
                                onClick={handleRemoveSignature}
                              >
                                {t("Button_Delete_Data")}
                              </button>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <button
                                type="button"
                                className="formgeneral-action-btn formgeneral-btn-insert"
                                disabled={pdfUrl === ""}
                                onClick={() =>
                                  insertDateInPDF(
                                    pdfUrl,
                                    signDispatchedOptTrasCanvas,
                                    signDispatchedDestTrasCanvas,
                                    signDispatchedRefundCanvas,
                                    setPdfUrl
                                  )
                                }
                              >
                                {t("Button_Insert_Data")}
                              </button>
                            </Grid>
                          </Grid>
                        </div> 
                      </div>
                    </div> 
                  </div>
                  <div className="signature-pdf">
                    {pdfUrl ? (
                      <iframe src={pdfUrl} title="Documento PDF" />
                    ) : (
                       <div style={{ textAlign: 'center', padding: '20px' }}>
                          {t("Text_Form_PDF_NOT_FOUND")}
                        </div>
                    )}
                  </div>
                </div> 
              </>:
                <LoadingNews/>
            }
            </form>
          </Box> 
     </div>
      //* End Page Content *//
    ) :  null }
  </>
  )    
}